module.exports = __webpack_public_path__ + "img/image-guidelines.95583f28.jpg";